import CardProfile from 'components/CardProfile';
import Layout from 'Layout';
import React from 'react'
import cx from 'classnames';
import PP from "assets/images/pp.png";
import GroupShare from 'components/GroupShare';


export default function PostPerangkat() {
     const elipseClasses = cx({
       "absolute  rounded-full shadow -z-[1] top-1/3  w-[130px] h-[130px] ": true,
     });
     
  return (
    <Layout>
      <div className="px-5 xl:pt-56 pt-28 kegiatan-wrapper xl:px-99">
        <h1 className="text-2xl font-bold xl:text-7xl">Kepala Desa</h1>
        <div className="w-full space-y-5 xl:space-y-0 inner xl:flex xl:space-x-5 my-[90px]">
          <CardProfile
            nama="Ibrahim, S. A. g"
            jabatan="Geuchik Gampong"
            hp="(+62) 82300877782"
            email="glgteungoh@gmail.com"
            profileImage={PP}
          />
          <div className="px-16 relative py-32 bg-transparent z-0 border xl:w-[70%] sambutanWrapper rounded-2xl border-borderCardFeatures">
            <div className={`left-0 orangeElipse ml-14 ${elipseClasses}`} />
            <span className="block text-xs font-medium md:text-base mb-9">
              Ibrahim, S. A. g
            </span>
            <p className="text-justify md:text-base ">
              Kepala desa adalah pejabat pemerintah desa yang mempunyai
              wewenang, tugas dan kewajiban untuk menyelenggarakan rumah tangga
              desanya dan melaksanakan tugas dari pemerintah dan pemerintah
              daerah.
            </p>
            <span className="block mb-4 text-xs md:text-base mt-9">
              Media Sosial
            </span>
          <GroupShare/>
          </div>
        </div>
      </div>
    </Layout>
  );
}
